import React, { useEffect, type ReactElement, useState } from 'react'
import {
    Col,
    DatePicker,
    type DatePickerProps,
    Form,
    Input,
    Row,
    Space,
} from 'antd'
import { connect } from 'react-redux'
import {
    type RegisterInterface,
    type PersonalDetails,
} from '../../../../../../Types/Client/RegisteredClients/SoleTrader'
import dayjs from 'dayjs'
import moment from 'moment'
import InputFieldNINumber from '../../../../../../Components/InputNINO'
// import { validateDate } from '../../../../../../Utils/ValidateDate'

const PersonalDetailsForm = (props: PersonalDetails): ReactElement => {
    const { soleTraderTaps, setSelectedDateFromChild } = props
    const [selectedDate, setSelectedDate] = useState<string>('')
    const [form] = Form.useForm()
    useEffect(() => {
        const initialDate = moment(
            soleTraderTaps?.soleTraderPersonalDetails?.dateOfBirth,
            'M/D/YYYY'
        )
        const formattedDate = initialDate.format('M/D/YYYY')
        setSelectedDate(formattedDate)
        setSelectedDateFromChild(dayjs(formattedDate).format('DD/MM/YYYY'))
    }, [soleTraderTaps?.soleTraderPersonalDetails?.dateOfBirth])

    const onChange = (dateOfBirth: DatePickerProps['value']): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
            setSelectedDateFromChild(isoDate)
            form.setFieldValue('dateOfBirth', isoDate)
            void form.validateFields(['dateOfBirth'])
        }
    }
    return (
        <>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <Form.Item
                        label="Date Of Birth"
                        name="dateOfBirth"
                        // rules={[
                        //     {
                        //         validator: async (_, value) =>
                        //             await validateDate(value),
                        //     },
                        // ]}
                    >
                        <Space
                            direction="vertical"
                            size={12}
                            style={{ width: '100%' }}
                        >
                            <DatePicker
                                allowClear
                                onChange={onChange}
                                value={
                                    selectedDate.length > 0
                                        ? dayjs(selectedDate)
                                        : null
                                }
                                format="DD/MM/YYYY"
                                disabledDate={(current) =>
                                    current !== null &&
                                    current > dayjs().endOf('day')
                                }
                                style={{ width: '100%' }}
                            />
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    {' '}
                    {/* <Form.Item label="NI Number" name="niNumber">
                        <Input allowClear maxLength={9} />
                    </Form.Item> */}
                    <InputFieldNINumber name="niNumber" form={form} />
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <Form.Item label="Nationality" name="nationality">
                        <Input allowClear maxLength={100} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    {' '}
                    <Form.Item
                        label="Mobile Number"
                        name="mobileNumber"
                        rules={[
                            {
                                pattern: /^\d{10,15}$/,
                                message:
                                    'Please enter a valid Mobile number (10 to 15 digits).',
                            },
                            {
                                required: true,
                                message: 'Please input your mobile number!',
                            },
                        ]}
                    >
                        <Input allowClear />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    {' '}
                    <Form.Item
                        label="Home Number"
                        name="homeNumber"
                        rules={[
                            {
                                pattern: /^\d{10,15}$/,
                                message:
                                    'Please enter a valid Home number (10 to 15 digits).',
                            },
                        ]}
                    >
                        <Input allowClear />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    {' '}
                    <Form.Item
                        label="Work Number"
                        name="workNumber"
                        rules={[
                            {
                                pattern: /^\d{10,15}$/,
                                message:
                                    'Please enter a valid Work number (10 to 15 digits).',
                            },
                        ]}
                    >
                        <Input allowClear />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    {' '}
                    <Form.Item
                        label="Email Address"
                        name="emailAddress"
                        rules={[
                            {
                                type: 'email',
                                required: true,
                                message: 'Please input your email!',
                            },
                        ]}
                    >
                        <Input allowClear maxLength={100} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 8]}>
                <Col span={24}>
                    <Form.Item
                        label="Alternative Email Address"
                        name="alternativeEmailAddress"
                        rules={[
                            {
                                type: 'email',
                                message: 'Please input valid email!',
                            },
                        ]}
                    >
                        <Input allowClear maxLength={100} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    )
}

const mapStateToProps = (state: any): RegisterInterface => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
        soleTraderTaps: state.client.soleTraderTaps,
    }
}

export default connect(mapStateToProps)(PersonalDetailsForm)
